import emailjs from '@emailjs/browser';

// EmailJS configuration
const EMAILJS_CONFIG = {
  SERVICE_ID: process.env.REACT_APP_EMAILJS_SERVICE_ID,
  TEMPLATE_ID: process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
  PUBLIC_KEY: process.env.REACT_APP_EMAILJS_PUBLIC_KEY
};

// Initialize EmailJS
emailjs.init(EMAILJS_CONFIG.PUBLIC_KEY);

export const sendEnquiryEmail = async (enquiryData) => {
  try {
    // Prepare email template parameters
    const templateParams = {
      to_email: 'info.kalyantravels@gmail.com',
      from_name: enquiryData.name,
      from_email: enquiryData.email,
      phone: enquiryData.phone || 'Not provided',
      package_name: enquiryData.packageName || 'General Enquiry',
      start_date: enquiryData.startDate || 'Not specified',
      end_date: enquiryData.endDate || 'Not specified',
      message: enquiryData.message,
      reply_to: enquiryData.email
    };

    console.log('Sending email with params:', templateParams);

    const response = await emailjs.send(
      EMAILJS_CONFIG.SERVICE_ID,
      EMAILJS_CONFIG.TEMPLATE_ID,
      templateParams
    );

    console.log('Email sent successfully:', response);
    return { success: true, response };
  } catch (error) {
    console.error('Email sending failed:', error);
    return { success: false, error: error.message };
  }
};

// Alternative: Send using form element (if needed)
export const sendEnquiryEmailFromForm = async (formElement, enquiryData) => {
  try {
    const response = await emailjs.sendForm(
      EMAILJS_CONFIG.SERVICE_ID,
      EMAILJS_CONFIG.TEMPLATE_ID,
      formElement,
      EMAILJS_CONFIG.PUBLIC_KEY
    );

    console.log('Email sent successfully:', response);
    return { success: true, response };
  } catch (error) {
    console.error('Email sending failed:', error);
    return { success: false, error: error.message };
  }
};